<template>
    <v-dialog
        v-model="show"
        transition="dialog-bottom-transition"
        hide-overlay
        fullscreen
        dark
    >
        <v-card
            class="primary"
        >
            <v-toolbar
                color="primary"
                flat
                dark
            >
                <!-- LOGO -->
                <v-toolbar-items
                    class="mx-4"
                >
                    <router-link
                        :to="homepageRoute"
                        class="d-flex"
                    >
                        <img
                            alt="logo"
                            src="/svg/logo-white.svg"
                            contain
                            height="40"
                            class="mt-3"
                        >
                    </router-link>
                </v-toolbar-items>
                <v-spacer />
                <v-btn
                    icon
                    dark
                    @click="show = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-container>
                <v-row
                    v-if="isUserAuthenticated"
                    class="mb-3"
                >
                    <v-col
                        cols="12"
                        class="text-capitalize py-0"
                    >
                        <v-avatar
                            color="primary lighten-3"
                            left
                        >
                            <v-img
                                v-if="avatarLink && userSettings.show_avatar"
                                alt="User avatar image"
                                :src="avatarLink"
                            />
                            <v-icon v-else>
                                mdi-account-outline
                            </v-icon>
                        </v-avatar>

                        <template v-if="userSettings.show_name">
                            {{ $_user.full_name.toLowerCase() }}
                        </template>
                    </v-col>
                    <v-col cols="12">
                        <v-sheet
                            color="#AFA7D6"
                            rounded="xl"
                        >
                            <v-list
                                color="transparent"
                                light
                            >
                                <v-list-group
                                    no-action
                                    @click.stop="() => {}"
                                >
                                    <template #activator>
                                        <v-list-item-avatar>
                                            <v-icon>
                                                mdi-account-outline
                                            </v-icon>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Support Officer
                                            </v-list-item-title>
                                            <v-list-item-subtitle
                                                class="grey--text text--darken-3"
                                            >
                                                {{ accountOfficer.firstname }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>

                                    <v-list-item
                                        :href="`mailto:${accountOfficer.email}`"
                                        class="pl-4"
                                        dense
                                    >
                                        <v-list-item-avatar>
                                            <v-icon>
                                                mdi-email-outline
                                            </v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ accountOfficer.email }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action class="ma-0">
                                            <v-btn icon>
                                                <v-icon>
                                                    mdi-open-in-new
                                                </v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>

                                    <v-list-item
                                        :href="`https://wa.me/${accountOfficer.phone && accountOfficer.phone.substring(1)}`"
                                        target="_blank"
                                        class="pl-4"
                                        dense
                                    >
                                        <v-list-item-avatar>
                                            <v-icon>
                                                mdi-whatsapp
                                            </v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ accountOfficer.phone }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action class="ma-0">
                                            <v-btn icon>
                                                <v-icon>
                                                    mdi-open-in-new
                                                </v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>

                                    <v-list-item
                                        href="https://twitter.com/messages/compose?text=Hello&recipient_id=1177321542574845952"
                                        target="_blank"
                                        class="pl-4"
                                        dense
                                    >
                                        <v-list-item-avatar>
                                            <v-icon>
                                                mdi-twitter
                                            </v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                @kaoshinetwork
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action class="ma-0">
                                            <v-btn icon>
                                                <v-icon>
                                                    mdi-open-in-new
                                                </v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list-group>
                            </v-list>
                        </v-sheet>
                    </v-col>
                    <v-col
                        cols="12"
                        class="py-0 text-center"
                    >
                        <v-btn
                            class="mt-2"
                            depressed
                            outlined
                            rounded
                            @click="logout"
                        >
                            <v-icon left>
                                mdi-power
                            </v-icon>
                            Logout
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row>
                    <template>
                        <v-col
                            v-for="(item, key) in navItems"
                            :key="key"
                            cols="6"
                        >
                            <v-card
                                :to="item.route"
                                :exact="item.exact"
                                class="mobile-menu-item py-8 px-4 primary darken-1 text-center"
                                flat
                                @click="show = false"
                            >
                                <v-icon color="white">
                                    {{ `mdi-${item.icon}` }}
                                </v-icon>
                                <br>
                                {{ item.text }}
                            </v-card>
                        </v-col>
                    </template>

                    <template v-if="isUserAuthenticated && !comingSoon">
                        <v-col
                            v-for="(item, key) in menuNavItems"
                            :key="`menu-${key}`"
                            cols="6"
                        >
                            <v-card
                                :to="item.route"
                                :exact="item.exact"
                                class="mobile-menu-item py-8 px-4 primary darken-1 text-center"
                                flat
                                @click="show = false"
                            >
                                <v-badge
                                    color="error"
                                    v-if="item.key === 'transfers'"
                                    :content="$store.state.activeMatchesCount"
                                    :value="$store.state.activeMatchesCount"
                                >
                                    <v-icon color="white">{{ `mdi-${item.icon}` }}</v-icon>
                                    <br />
                                    {{ item.text }}
                                </v-badge>

                                <v-badge
                                    color="error"
                                    v-if="item.key === 'requests'"
                                    :content="$store.state.activeRequestsCount"
                                    :value="$store.state.activeRequestsCount"
                                >
                                    <v-icon color="white">
                                        {{ `mdi-${item.icon}` }}
                                    </v-icon>
                                    <br>
                                    {{ item.text }}
                                </v-badge>

                                <template v-if="!item.key">
                                    <v-icon color="white">
                                        {{ `mdi-${item.icon}` }}
                                    </v-icon>
                                    <br>
                                    {{ item.text }}
                                </template>
                            </v-card>
                        </v-col>
                    </template>
                </v-row>

                <v-row
                    class="justify-center mt-6"
                >
                    <v-col
                        cols="auto"
                    >
                        <v-btn
                            color="amber lighten-2"
                            depressed
                            text
                            v-if="isUserAuthenticated"
                            @click="comingSoon = !comingSoon"
                        >
                            Coming Soon
                            <v-icon right>
                                {{ comingSoon ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                            </v-icon>
                        </v-btn>
                        <p v-else class="amber--text text-uppercase">
                            Coming Soon
                        </p>
                    </v-col>
                </v-row>

                <v-expand-transition>
                    <v-row v-if="comingSoon">
                        <v-col
                            v-if="!$store.state.user.can_post_offers"
                            cols="6"
                        >
                            <v-card
                                class="mobile-menu-item py-8 px-4 primary darken-1 amber--text text--lighten-3 text-center"
                                flat
                                @click="showHealthModal = true"
                            >
                                <v-icon color="red">
                                    mdi-heart-pulse
                                </v-icon>
                                <br>
                                Health
                            </v-card>
                        </v-col>

                        <v-col
                            v-if="$store.state.user.can_post_offers"
                            cols="6"
                        >
                            <v-card
                                class="mobile-menu-item py-8 px-4 primary darken-1 amber--text text--lighten-3 text-center"
                                flat
                                @click="showInvoiceModal = true"
                            >
                                <v-icon>mdi-hand-heart</v-icon>
                                <br>
                                Invoice Money Internationally
                            </v-card>
                        </v-col>

                        <v-col
                            v-if="!$store.state.user.can_post_offers"
                            cols="6"
                        >
                            <v-card
                                class="mobile-menu-item py-8 px-4 primary darken-1 amber--text text--lighten-3 text-center"
                                flat
                                @click="showShoppingModal = true"
                            >
                                <v-icon color="#76CDD4">
                                    mdi-cart
                                </v-icon>
                                <br>
                                Shopping
                            </v-card>
                        </v-col>

                        <v-col
                            v-if="!$store.state.user.can_post_offers"
                            cols="6"
                        >
                            <v-card
                                class="mobile-menu-item py-8 px-4 primary darken-1 amber--text text--lighten-3 text-center"
                                flat
                                @click="showAutoLoanModal = true"
                            >
                                <v-icon color="yellow">
                                    mdi-car-estate
                                </v-icon>
                                <br>
                                AutoLoan
                            </v-card>
                        </v-col>

                        <v-col
                            v-if="!$store.state.user.can_post_offers"
                            cols="6"
                        >
                            <v-card
                                class="mobile-menu-item py-8 px-4 primary darken-1 amber--text text--lighten-3 text-center"
                                flat
                                @click="showWalletModal = true"
                            >
                                <v-icon color="green">
                                    mdi-wallet
                                </v-icon>
                                <br>
                                Wallet
                            </v-card>
                        </v-col>
                    </v-row>
                </v-expand-transition>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    /* eslint-disable arrow-body-style */
    /* eslint-disable no-else-return */
    import { mapGetters, mapActions } from 'vuex';

    const modals = [
        'showHealthModal',
        'showInvoiceModal',
        'showShoppingModal',
        'showAutoLoanModal',
        'showWalletModal',
    ];

    export default {
        data: () => ({
            comingSoon: false,
        }),
        mounted() {
            this.comingSoon = !this.isUserAuthenticated;
        },
        computed: {
            ...mapGetters([
                'userSettings',
                'isUserAuthenticated',
            ]),
            ...mapGetters('navigation', [
                'homepageRoute',
                'navItems',
                'menuNavItems',
            ]),
            show: {
                get() {
                    return this.$store.state.sidebar.show;
                },
                set(value) {
                    this.$store.commit('sidebar/SET_SHOW', value);
                },
            },
            ...modals.reduce((obj, item) => {
                return {
                    ...obj,
                    [item]: {
                        get() {
                            return this.$store.state.navigation[item];
                        },
                        set(value) {
                            this.show = false;
                            this.$store.commit('navigation/SET_MODAL_STATE', {
                                type: item,
                                value,
                            });
                        },
                    },
                };
            }, {}),
            avatarLink() {
                return this.$_user.avatar;
            },
            accountOfficer() {
                return this.$_user.accountOfficer || {};
            },
        },
        watch: {
            $route() {
                this.show = false;
            },
        },
        methods: {
            ...mapActions('auth', [
                'logout',
            ]),
        },
    };
</script>

<style>
.mobile-menu-item {
    height: 100%;
}
</style>
